import { RAG } from 'features/dashboard/charts/scoreColour'

export const canRejectAiFind = action => action?.status === 'pending_review' && !!action?.permissions?.canDismiss

export const STAGE_ORDER = ['awaiting_review', 'needs_decision', 'task_created', 'task_in_progress', 'resolved', 'dismissed']

export const STAGE_META = {
  awaiting_review: { label: 'Awaiting review', level: 'medium', text: 'Our AI found this in one of your documents. Someone needs to check it is real before it counts.' },
  needs_decision: { label: 'Needs a decision', level: 'high', text: 'Nobody has decided what to do yet. Create a task to fix it, or mark it complete if it is already fixed.' },
  task_created: { label: 'Task created', level: 'medium', text: 'A task has been created to put this right, but work has not started yet.' },
  task_in_progress: { label: 'Task in progress', level: 'medium', text: 'Work has started on at least one of its tasks. It closes by itself when every task is completed.' },
  resolved: { label: 'Resolved', level: 'low', text: 'Put right. Either all of its tasks were completed, or someone marked it complete.' },
  dismissed: { label: 'Dismissed', level: 'none', text: 'Closed without any work, with a reason recorded for the audit trail.' },
}

const UNKNOWN_STAGE = { label: 'Unknown stage', level: 'none', text: 'We could not work out the stage of this remedial.' }

const IMPORTED_OPEN = {
  label: 'Still open in the previous system',
  level: 'high',
  text: 'This was still open when the records moved from the system used before Building Passport, so nobody has put it right yet. Create a task to fix it, or mark it complete if it is already fixed.',
}

export const stageMeta = (stage, action = null) => {
  const meta = stage === 'needs_decision' && action?.metadata?.imported ? IMPORTED_OPEN : STAGE_META[stage] || UNKNOWN_STAGE
  const rag = RAG[meta.level] || RAG.none
  return { ...meta, color: rag.fg, bg: rag.bg }
}

export const SEVERITY_ORDER = ['critical', 'high', 'medium', 'low']

export const SEVERITY_META = {
  critical: { label: 'Critical', text: 'Could put people in danger or break the law now. Put it right within days.' },
  high: { label: 'High', text: 'A serious problem. Put it right soon.' },
  medium: { label: 'Medium', text: 'Needs putting right, but it is not urgent.' },
  low: { label: 'Low', text: 'A minor issue. Put it right when it is convenient.' },
}

export const severityMeta = level => {
  const meta = SEVERITY_META[level] || { label: 'Unknown', text: '' }
  const rag = RAG[level] || RAG.none
  return { ...meta, color: rag.fg, bg: rag.bg }
}

export const DEFAULT_DUE_DAYS = { critical: 7, high: 30, medium: 90, low: 180 }

export const SOURCE_LABEL = {
  guru: 'From a document',
  incident: 'From an incident',
  task_form: 'From a task form',
  manual: 'Added manually',
  imported: 'Imported from previous system',
}

export const sourceLabel = source => SOURCE_LABEL[source] || 'Other'
